import { call, put, take } from 'redux-saga/effects';

import rulesJson from 'lib/constraintsChecker/fixtures/rules.json';
import messagesJson from 'lib/constraintsChecker/fixtures/messageRules.json';
import messagesJsonEn from 'lib/constraintsChecker/fixtures/messageRules_en.json';
import messagesJsonNl from 'lib/constraintsChecker/fixtures/messageRules_nl.json';
import messagesJsonDe from 'lib/constraintsChecker/fixtures/messageRules_de.json';

import ActionTypes, { RULES_MESSAGES_URL, RULES_URL } from '../constants/rules';
import { requestGet } from 'utils/requests';
import { Rule } from 'lib/constraintsChecker/Rule';
import {
  getRulesFailure,
  getRulesSuccess,
} from 'containers/Configurator/actions/rules';
import { ActionMessage } from 'lib/constraintsChecker/ActionMessage';
import {
  loadMessagesFromJson,
  loadRulesFromJson,
} from 'lib/constraintsChecker/data';
import i18n from '../../../i18n';

export function* downloadRulesFromAPI() {
  if (true || process.env.NODE_ENV !== 'production') {
    let messagesJsonData: any;
    switch (i18n.language) {
      case 'nl':
        messagesJsonData = messagesJsonNl;
        break;
      case 'en':
        messagesJsonData = messagesJsonEn;
        break;
      case 'de':
        messagesJsonData = messagesJsonDe;
        break;
      default:
        messagesJsonData = messagesJson;
    }

    const messages = loadMessagesFromJson(JSON.stringify(messagesJsonData));
    const rules = loadRulesFromJson(JSON.stringify(rulesJson));
    yield put(getRulesSuccess(rules, messages));
    return rules;
  } else {
    const url = `${RULES_URL}/`;
    const urlMessages = `${RULES_MESSAGES_URL}/`;
    try {
      const response = yield call(requestGet, url);
      const rules: Rule[] = loadRulesFromJson(response);
      const responseMessages = yield call(requestGet, urlMessages);
      const messages: ActionMessage[] = loadMessagesFromJson(responseMessages);
      yield put(getRulesSuccess(rules, messages));
      return rules;
    } catch (error) {
      yield put(getRulesFailure(error));
    }
  }
}

export default function* rulesSaga() {
  while (true) {
    yield take(ActionTypes.RULES_REQUEST);
    yield call(downloadRulesFromAPI);
  }
}
